import type { RedirectPropsApi } from '@omnia/ui/src/lib/cms/core-components/redirect/models'
import type { CmsImageWithFocalPoint } from '@omnia/ui/src/lib/cms/types/cmsImageWithFocalPoint'
import { PageBase } from '@omnia/ui/src/lib/services/models/pageBase'
import type { GridRow } from '@/cms/grid/components/grid/grid.types'
import type { ExtensionDef } from '../extensions/extensions'

export class PageResponse extends PageBase {
    public heroImage?: CmsImageWithFocalPoint
    public components: { [componentName: string]: unknown }
    public extensions: { [extensionName: string]: unknown } = {}
    public readonly extensionDefs: Readonly<Array<ExtensionDef<unknown>>> = [] as const
    public ancestorComponents: { [pageName: string]: { [componentName: string]: unknown } }
    public gridContent: GridRow[]
    public redirectDetailsElement: RedirectPropsApi
    public pageSubtitle: string
    public useGenericHeroBanner: boolean

    public getExtension<T>(def: ExtensionDef<T>): T {
        return this.extensions[def.name] ? def.mapper(this.extensions[def.name]) : (null as T)
    }

    public getExtensions<M extends object, T extends ReadonlyArray<ExtensionDef<M>>>(
        ...values: T
    ): { -readonly [P in keyof T]: ReturnType<T[P]['mapper']> } {
        return values.map(value => {
            return this.getExtension(value)
        }) as { -readonly [P in keyof T]: ReturnType<T[P]['mapper']> }
    }
}
